import { Alert, alertClasses, AlertTitle, Button, Collapse, Grid, Typography } from "@mui/material";
import * as Sentry from "@sentry/react";
import { useState } from "react";

const ErrorBoundary : Sentry.FallbackRender = ({ error: e, componentStack }) => {
    // Get error from the route context.
    const error = e as any;

    console.log(error);

    const [details, setDetails] = useState(false);
    
    return (
        <>
            <Alert
                sx={{
                    margin: 2,
                    [`& .${alertClasses.message}`]: {
                        width: "100%"
                    }
                }}
                severity="error"
            >
                <AlertTitle>An error has occurred!</AlertTitle>
                <Typography gutterBottom>
                    Please refresh the page and try again.
                </Typography>
                {
                    error?.message && (
                        <Typography gutterBottom>
                            <strong>Error:</strong> <em>{error.message}</em>
                        </Typography>
                    )
                }
                <Grid
                    container
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%"
                    }}
                    gap={2}
                >
                    <Grid>
                        {
                            componentStack && (
                                <>
                                    <Button onClick={() => setDetails(c => !c)} color="error">
                                        More Details
                                    </Button>
                                </>
                            )
                        }
                    </Grid>
                    <Grid>
                        <Button
                            component="a"
                            href={"/"}
                            variant="contained"
                            color="error"
                        >
                            Home
                        </Button>
                    </Grid>
                </Grid>
                {
                    componentStack && (
                    <Collapse in={details}>
                        <pre>
                            {componentStack}
                        </pre>
                    </Collapse>
                    )
                }
            </Alert>
        </>
    );
}
export default ErrorBoundary;